import { endOfYear, subYears } from "date-fns";
import * as Yup from 'yup';
import { dateIsBefore } from '../../../../util/validacionesYup';

const maxFechaIngreso = endOfYear(subYears(new Date(), 1));

export const trabajadoresValidation = (trabajadores) => Yup.object().shape({
  idTrabajador: Yup.string().nullable().required("Campo Obligatorio").test({
    name: "sinTrabajadoresRepetidos",
    message: "El trabajador ya está registrado en la grilla.",
    test: function (value) {
      return !trabajadores.some((t, index) => {
        return t?.idTrabajador.toString() === value && index !== this.parent?.index
      });
    }
  }),
  idSector: Yup.string()
    .nullable()
    .required("Campo Obligatorio"),
  idPuesto: Yup.string()
    .nullable()
    .required("Campo Obligatorio"),
  fechaIngreso: Yup.date().nullable()
    .required("Campo Obligatorio")
    .typeError('Fecha inválida')
    .test({
      name: "fechaLimiteVerificacion",
      message:
        "La fecha de ingreso no puede ser posterior al 31/12 del año anterior.",
      test: (value, testContext) => {
        if (!value) {
          return true;
        }

        return dateIsBefore(value, maxFechaIngreso);
      },
    }),

})